// 请保证所有语言包 的Key值都一直
export default {
  login: {
    username: 'userName',
    password: '密码',
    logOut: "Log In Again",
    accessPermissions: 'You have no permission to access the configurator',
    businessSupport: "Service Support",
    questionsContact: 'If you have any questions, contact',
    technicalSupport: 'Technical Support',
  },
  // 首页模块
  homePage: {
    whetherOut: 'Are you sure you want to log out?',
    cancelOut: 'The operation has been canceled',
    alternativeModels: 'Replacement Model',
    filter: 'Filtering Conditions',
    accordingProvider: 'Display Service Provider Exclusive Supply',
    exportDefault: 'Export Fields by Default',
    whetherOpen: 'Enable',
    productAutomaticMemory: 'Auto Remember Product Name',
    parameterAutomaticMemory: 'Auto Remember Parameters',
    viewDetails: 'View Details',
    quotationOnly: 'Quotation Number:',
    compile: 'Edit',
    high: 'High',
    toReplace: 'Replace',
    operationRecords: 'Action Records',
    anOperationRecords: 'Expand',
    closingOperationRecords: 'Collapse',
    operatingTime: 'Time',
    operatingContent: 'Description',
    quotation: 'Price List',
    product: 'Product',
    quotationSearch: 'Search by Price List Name or Remarks',
    recommendation: 'You are advised to use Google, Firefox, 360 Extreme, Sogou and other non-IE browsers. If a network error occurs or the loading speed is too slow, please refresh the page or clear the cache.',
    productInquire: 'Product Search',
    enterProductModel: 'Enter device model',
    searchProductModel: 'Search by Model or Description',
    technicalSupport: 'Technical Support',
    supplyBusinessSupport: 'Supply Risk Service Support',
    productLineContact: 'Contact Info',
    operationalService: 'Operational guidelines for school official cites use of the service policy',
    operationGuide: 'User Guide',
    yourAdvice: 'Suggestions',
    newAccurate: 'Accurate association is added. How do you like this function? (After a device is selected, proper accessories are automatically selected for use.)',
    configuratorOverall: 'How do you like the configurator?',
    otherSuggestions: 'Other Suggestions',
    pleaseEnterComments: 'Enter suggestions.',
    takeAway: 'Cancel',
    save: 'save',
    addmaintenanceservice: 'Add a maintenance service',
    servicetype: 'Service type',
    lengthofservice: 'Length of service (year)',
    pleaseselectservicetype: 'Please select a service type',
    pleaseselectserviceduration: 'Please select the service duration',
    confirm: 'OK',
    submitTo: 'Submit to',
    deleteOk: 'Yes, delete it',
    pleaseEnterContent: 'Please enter the content',
    search: 'Search',
    reset: 'Reset',
    advancedSearch: 'Advanced Search',
    clickProductLine: 'Click to select product line.',
    clickProductCategories: 'Click to select product category.',
    clickProductSeries: 'Click to select product series.',
    accordingHost: 'Display Device',
    accordingServiceProviders: 'Display Service Provider',
    ruleWrongWantFeedback: 'Feedback on Configurator Rules',
    productChangeThat: 'Product change that',
    wantScore: 'Score',
    contactUs: 'Contact Us',
    operatingInstructions: 'User Guide',
    videoDirection: 'Video Guide',
    changeLog: 'Log Update',
    personalSetting: 'Settings',
    userAuthorization: 'User License',
    logOut: 'Log Out',
    createQuotation: 'Create Price List',
    managementQuotation: 'Manage Price List',
    myQuotation: 'My Price List',
    notClassified: 'Unclassified',
    recycleBin: 'Recycle Bin',
    myCreated: 'Created by Me',
    complianceStatus: 'Compliance Status',
    myShareThe: 'Shared by Me',
    createFolder: 'Create Subfolder',
    modifyFolderSonName: 'Edit Subfolder Name',
    deleteFolder: 'Delete Subfolder',
    emptyRecycle: 'Empty Recycle Bin',
    sharedObject: 'Shared Person',
    sharingTime: 'Shared Time',
    checkTime: "View Record",
    activate: "Activate",
    productsPulledQuotation: 'Your quotation contains the products that have been taken down.',
    serviceProvidersQuotation: 'Service providers for products in your quotation',
    shortagesProductsQuotation: 'Your quotation contains the products in short supply.',
    currentProjectCycle: 'The stocking cycle of the current project is',
    DaysCRMSystem: 'days. Select stocking on the CRM system in advance.',
    expectedEaseDate: 'Expected Ease Date',
    quantityDemanded: "Quantity",
    details: 'Details',
    productModel: "Product Model",
    stockCycle: 'Stocking Cycle',
    status: 'Status',
    alternativeProductModel: 'Replacement Model',
    projectName: 'Project Name',
    businessCode: 'Service Opportunistic Code:',
    exportSales: 'Foreign Sales:',
    saleTechnicalSupport: 'Pre-sale Technical Support:',
    specifyPeopleShare: 'Shared Person:',
    pleaseEnterDesignatedShare: 'Specify a shared person',
    name: 'Name',
    department: 'Division',
    notHave: 'None',
    channelType: 'Channel Type',
    customizeWizard: 'Custom Folder',
    selectDiscountRefresh: 'Select a method to refresh the discounted price',
    newFolder: 'Add Folder',
    modifyFolderName: 'Edit Folder Name',
    pleaseFillPerson: 'Specify a shared person',
    shareSuccess: 'Operation succeeded',
    notAvailable: 'No Data',
    permissionsProducts: 'Product Permissions,',
    pleaseModifyShare: 'Edit the product list before sharing.',
    failureReasons: 'Cause:',
    userNoCRMInformation: 'This user has no CRM project',
    deleteProjectContinue: "All items in the quotation will be deleted. Continue?",
    prompt: 'Tip',
    deletedSuccessFully: "Deletion succeeded!",
    deleteProjectFailure: "Deletion failed. Contact the admin for help!",
    copyQuotationProject: 'All items in the quotation will be copied. Continue?',
    copySuccess: 'Operation succeeded!',
    copyProjectFailureError: "Operation failed. Contact the admin for help!",
    hasBeenActivated: 'Activation succeeded. You can edit and use the quotation on the home page？',
    activateSuccess: "Activation succeeded!",
    activateError: "Activation failed. Contact the internal developer!",
    refreshPrice: "Are you sure you want to refresh the price?",
    modifyFailureError: "Operation failed!",
    pleaseSelectFolder: 'Select a folder',
    newFolderLevel: 'A new folder supports up to 2 levels',
    onlyCreateFolder: 'A subfolder can be created only in the My Quotation folder',
    onlyDeleteFolder: 'Only the subfolder of the My Quotation folder can be deleted',
    deleteFoldersConfirm: 'After the folder is deleted, all quotations in the folder are moved to the recycle bin. Continue?',
    deleteFailureAdministrator: 'Deletion failed. Contact the admin for help!',
    confirmRecycleBin: 'Are you sure you want to empty the recycle bin?',
    emptyRecycleSuccess: 'Operation succeeded!',
    emptyRecycleFailure: 'Operation failed. Contact the internal developer!',
    errorGettingUser: 'Failed to fetch the classification of user folders',
    newFolderSuccess: 'Operation succeeded',
    newFolderRepeated: 'The name of the new folder cannot be empty or repeated',
    modifyTheFolderName: 'Operation succeeded',
    modifyFolderNotRepeated: 'The name of the edited folder cannot be empty or repeated',
    moveQuotationSuccess: 'Operation succeeded',
    mobileQuotationFailure: 'Operation failed',
    verySolutionGuide: 'Purchasing Guide for ELV Box',
    projectMinimalistPrompt: '1. If the SOE switch is deployed in the ELV box, you are advised to purchase the specified ELV box. Adopt the specified ELV box (tested by Ruijie Networks) whose enclosure temperature is only 10℃/50℉ higher than the ambient temperature. And the components of the ELV box can be installed or removed. Note: The open area of other products on the market does not meet standard, causing high temperature in the enclosure of the device',
    weakProvidingFollowingModels: '2. ELV boxes shall be purchased through cooperation with third-party suppliers. The following models are available:',
    TheRules: 'Rule',
    size: 'Dimensions (W × D × H)',
    priceTax: 'Tax-Inclusive Price (tax-exclusive price: reduced by 13% of the price)',
    builtWeakCurrent: 'Built-in ELV box (including base and door panel), extension socket, without a fiber-optic splice tray (additional purchase allowed)',
    embeddedBoxPlank: 'Built-in ELV box door panel (including door panel only)',
    wallHungLowBox: 'Wall-mounted ELV box (including base and door panel), extension socket, without a fiber-optic splice tray (additional purchase allowed)',
    orderChannel: '3. Ordering channel: Contact Mr. Wang (Manager)',
    alibabaPurchaseLink: 'Alibaba purchasing link:',
    notePrice: 'Note: If you need an invoice, enter remarks. No invoice is issued by default. The tax-inclusive price is higher than the tax-exclusive price.',
    orderPurchaseDays: '4. Use full cash transfer for ordering. The goods are delivered to you in 14 days after payment.',
    networkAnomaly: 'Network Error',
    moveTheTo: 'Move to',
    shareWithMe: 'Shared to Me',
    theNameList: 'Price List Name:',
    directoryTotalPrice: 'List Price (USD)',
    lastModified: 'Last Modified At',
    source: 'Source',
    shareRecord: 'Sharing Records',
    operate: 'Action',
    modify: 'Edit',
    delete: 'Delete',
    remarks: 'Remarks',
    copy: 'Copy',
    export: 'Export',
    share: 'Share',
    moveTo: 'Move to',
    theRefreshPrice: 'Refresh Price',
    page: 'Page',
    article: 'article',
    leaveFor: 'Go to'
  },
  // 导出模块
  exportExcelModule: {
    myQuotation: 'My Price List',
    exportTheShare: 'Export and Share',
    exportExcel: 'Export excel',
    exportFieldScreening: 'The export field screening',
    exportField: 'The export field:',
    exportFormat: 'Export format',
    productSeries: 'Product Series',
    productName: 'Product Name',
    productModel: 'Product Model',
    productDes: 'Description',
    directoryPrice: 'Directory the unit price',
    totalNumber: 'Quantity',
    catalogPrice: 'Catalog price',
    subtotalConfigurationGroup: 'With subtotal configuration group',
    withListTotal: 'With the whole list in total',
    withServiceSet: 'With service configuration set',
    coverWithExcel: 'Cover with Excel',
    continueExport: 'Continue to export',
    downloadSOW: 'Download the Service SOW',
    keepStaring: 'Keep Staring'
  },
  //  创建报价单模块
  createQuotation: {
    sellsArea: 'Sales Area',
    enterRegionName: 'Enter a sales area name',
    totalPriceAfterDiscount: 'Net Price:',
    pleaseDiscountValue: 'Enter a discount value.',
    applicationGuideDiscount: 'Apply Guidance Discount',
    configurationSet: 'Config Group',
    guideDiscount: 'Guidance Discount',
    theDiscountValue: 'Discount (%)',
    subtotal: 'Total',
    discountOnlyNumbers: 'Only positive numbers with up to two decimal places are allowed',
    discountCannotHigher: 'A value more than 100% is not allowed',
    discountCannotNegative: 'Negative numbers are not allowed',
    discountSuccessfully: 'Calculation succeeded',
    discountCalculatedFailure: 'Calculation failed',
    discountCalculationSaveFailed: 'Save failed',
    share: 'Share',
    shareFailure: 'Failure. Causes:',
    wordText: 'Character',
    pleaseNameQuotation: 'Enter quotation name',
    lengthExceedCharacters: 'Up to 200 characters are allowed',
    networkAnomaly: 'Network Error',
    addServiceConfigurationGroup: 'Add Service Config Group',
    sceneChange: 'Scene change', // 删除字段
    modifyProgram: 'Modify the program', // 删除字段
    modifyProduct: 'Edit Product',
    delete: 'Delete',
    copy: 'Copy',
    addProduct: 'Add Product',
    operation: 'operation',
    previousStepBasicInformation: 'Back to Enter Basic Info',
    nextProductDiscounts: 'Go to Enter Discount',
    addConfigurationSet: 'Add Config Group',
    enterGroupName: 'Enter group name',
    cancel: 'Cancel',
    add: 'Add',
    moreCharacters: 'Up to 40 characters are allowed',
    addGroupSuccess: 'Operation succeeded!',
    sortModifySuccess: 'Operation succeeded!',
    takeAway: 'Cancel',
    confirm: 'determine',
    deleteSucceeded: 'Delete the success!',
    deleteErrorMessage: 'Operation failed. Contact the admin for help!',
    copyErrorMessage: 'Operation failed. Contact the admin for help!',
    editGroupNameSuccess: 'Operation succeeded!',
    myQuotation: 'My Price List',
    projectBasicInformation: 'Basic Info',
    productConfigurationList: 'Configure Product List',
    discountInformation: 'Enter Discount',
    exportShare: 'Export and Share',
    theNameList: 'Price List Name:',
    EcpProjectRelated: 'ECP Project Name',
    customerName: 'Customer Name',
    pleaseInputClientName: 'Enter customer name',
    fileNameFolder: 'File Name',
    quotationNote: 'Remarks',
    belongGroup: 'Division',
    cancelledReturnMyQuotation: 'Back to My Price List',
    nextConfigureProductList: 'Go to Configure Product List',
    pleaseEnterNameList: 'Enter a price list name',
    pleaseEnterECPProjectName: 'Enter project name',
    pleaseEnterNoteInformation: 'Enter remarks',
    pleaseEnterTheContent: 'Enter division',
    catalogPrice: 'List Price',
    modifyConfigurationGroupName: 'Edit Config Group Name',
    configurationGroupName: 'Config Group Name',
    sequenceShows: 'Display in Reverse Order',
    configurationSetType: 'Config Group Type',
    creationDate: 'Created At',
    thisOperationCopyContinue: 'The selected products will be deleted. Continue?',
    cancelledCopy: 'This operation has been canceled',
    thisPermanentlyDeleteContinue: 'The selected series and products will be deleted. Continue?',
    hasBeenDelete: 'This operation has been canceled',
    drag: 'Drag',
    addSolution: 'Add the solution to',
    addGeneralConfigurationGroup: 'Add General Config Group',
    conventional: 'General',
    service: 'Service',
    discountPrice: 'Net Price',
    wholeSingleDiscount: 'Discount:',
    setDiscountValue: 'Set Discount(%):',
    editConfigurationGroup: 'Config Group',
    configurationSeries: 'Product Series',
    pleaseEnterDiscount: 'Enter discount',
    application: 'Apply',
    reset: 'Reset',
    productSeries: 'Product Series',
    productName: 'Product Name',
    productModel: 'Product Model',
    discountValue: 'Discount (%)',
    directoryPrice: 'List Price (USD)',
    serviceUnitPrice: 'Service the unit price (USD)',
    salesUnitPrice: 'Promotion Price (USD)',
    afterFoldingUnitPrice: 'Net Price (USD)',
    totalNumber: 'Quantity',
    totalQuantity: 'Save',
    stepConfigurationList: 'Back to Configure Product List',
    nextStep: 'Go to Export and Share',
    exportQuotation: 'Export Price List',
    shareQuotation: 'Share Price List',
    returnQuotationList: 'Back to Price List',
    createNewQuotation: 'Create New Price List',
    prompt: 'Tip',
    copyQuotationContinue: 'All items in the price list will be copied. Continue?',
    exportTheShare: 'Export and Share',
    quotationPromptInformation: 'Tip',
    crmSystemDate: 'The stocking cycle of the current project is 120 days. Check the stocking on the CRM system in advance',
    continueExport: 'Continue',
    exportFieldScreening: 'Field Filtering',
    straussClickViewDetails: 'If the simplified optical switch is deployed in the ELV box, the specified ELV box must be purchased. Click to view the details',
    shortagesQuotation: 'Your price list contains the products in short supply',
    quotationDeliStingProducts: 'Your price list contains the delisted products:',
    canReplaceQuotation: 'Your price list contains the products that can be replaced:',
    ECPProjectsShare: 'ECP Project Sharing:',
    designatedShare: 'Specified Sharer',
    deleteWhetherContinue: 'All items in the price list will be deleted. Continue?',
    moveFolder: 'Move to File',
    theRefreshPrice: 'Refresh Price',
    pleaseDiscountPrice: 'Select a method to refresh the discounted price',
    discountSame: 'Discount Unchanged',
    discountedUnchanged: 'Net Price Unchanged'
  },
  // 添加配置组模块
  addConfigModule: {
    rulesMessage: 'Enter a product combination name',
    rulesNumberMessage: 'No more than 40 characters',
    packageRulesName: 'Enter a product combination name',
    specialCharacters: 'Special characters are not allowed',
    myQuotation: 'My Price List',
    productConfigurationGroup: 'Product Config Group',
    addProduct: 'Add Product',
    productAdded: 'Added Products',
    search: 'Search',
    reset: 'Reset',
    close: 'Close',
    productModel: 'Product Model',
    noMore: 'End',
    clickProductLine: 'Click to select product line.',
    clickProductCategories: 'Click to select product category',
    clickProductSeries: 'Click to select product series.',
    productCategory: 'Product Category',
    productLine: 'Product Line',
    productRange: 'Product Series',
    deploymentConfiguration: 'Expand Config',
    editConfigurationGroup: 'Edit Config Group',
    pleaseEnterTheContent: 'Enter keywords',
    determine: 'OK',
    preListingTime: 'Expected Listed Time',
    marketRetailPrice: 'Retailer Price',
    productDescription: 'Description',
    networkAnomaly: 'Network Error',
    enterGroupName: 'Enter group name',
    cannotExceedCharacters: 'Up to 40 characters are allowed',
    editGroupNameSuccess: 'Operation succeeded!',
    addGroupNameSuccess: 'Operation succeeded!',
    changeNotProduct: 'No product is selected!',
    expandOrCloseAll: 'Expand/Collapse All',
    productName: 'Product Name',
    productDes: 'Description',
    enterProductName: 'Enter a product name',
    editProductNameSuccess: 'Operation succeeded!',
    QueryProductModelOrDescription: 'Search for Device Model or Description',
    day: 'Days',
    yuan: 'USD',
    zhi: 'to',
    wu: 'None',
    promotionPrice: 'Promotion Price',
    promotionTime: 'Promotion Time',
    serviceProviderPrice: 'Service Provider Price',
    batchProduction: 'Mass Production',
    remainingInventoryClearing: 'Inventory Clearance',
    stopPlacingAnOrder: 'Stop Placing Orders',
    reportingLock: 'Report for Lock',
    productConfigRelationshipReminder: 'Product Config Relationship Reminder',
    continueSavingChanges: 'Save',
    continueSavingClose: 'Save and Close',
    collectionOfProductsSucceeded: 'Operation succeeded!',
    cancelFavoriteProductsSuccessfully: 'Cancellation succeeded!',
    accordingProductClassification: 'Load Category by Product Line',
    //  第二批翻译,丢失的字段
    hideComboPackage: 'Hide Combination Package',
    myCollection: 'Single Product',
    cancelFavoriteProduct: 'Are you sure you want to cancel the favorite?',
    prompt: 'Tip',
    cancelCollectionSuccessfully: 'Operation succeeded!',
    failedCancelCollectionContactAdmin: 'Operation failed. Contact the admin for help!',
    productTips: 'Tip',
    productsAddedChangedPleaseReCollect: 'Some products you added have changed. Add them to favorites again',
    myFavoritePortfolio: 'Product Combination',
    searchPortfolioName: 'Search by Product Combination Name',
    assortmentName: 'assortment Name',
    discountFont: 'Description',
    price: 'Price',
    editSingleProductNumSuccessfully: 'Operation succeeded',
    editSingleProductNumFaild: 'Operation failed',
    deleteProductsMsg: 'The selected series and products will be deleted. Continue?',
    hasBeenDelete: 'This operation has been canceled',
    deletedCombinedProductSuccessfully: 'deleted Combined Product Success fully',
    deletedCombinedProductFail: 'deleted Combined Product Fail',
    editCombinedProductNameSuccessfully: 'edit Combined Product Name Successfully',
    editCombinedProductNameFail: 'edit Combined Product Name Fail',
    editCombinedProductNameFailMsg: 'edit Combined Product Name Fail Msg',
    preciseCorrelation: 'Precise',
    fuzzySearch: 'Fuzzy',
    //  第二批翻译,丢失的字段 end
    selectAll: 'Select All',
    save: 'Save',
    deconfigure: 'Configure',
    deleteSucceeded: 'Deletion succeeded',
    saveSucceeded: 'Save succeeded',
    deleteSelecedProductsMsg: 'The selected products will be deleted. Continue?',
    deleteSelecedXlAndProductsMsg: 'The selected series and products will be deleted. Continue?',
    addConfigurationSet: 'Add Config Group',
    configurationGroupName: 'Config Group Name',
    cancel: 'Cancel',
    add: 'Add',
    fuzzyClickHost: 'Click to select device model',
    searchProductModel: 'Search by Product Model or Description',
    hideDeliSting: 'Hide Delisted Products',
    hiddenFor: 'Hide Custom Products',
    hideLightModule: 'Hide Optical Modules',
    accordingHost: 'Display Device',
    hostLightModule: 'Device + Optical Modules',
    accordingServiceProviders: 'Display Service Provider',
    myFavorite: 'Favorites',
    addProductConfigureGroup: 'Add Products to Config Group',
    allOpenOrClosed: 'All open or closed',
    priceRMB: 'Price (USD)',
    theNumber: 'Quantity',
    operation: 'Action',
    status: 'Status',
    periodAfterPreparationTime: 'Stocking Cycle',
    leadTime: 'Lead Time',
    orderPreparationTime: 'Order Preparation Time',
    Represents: '1. Represents the production preparation period under the premise of forecast reporting. ',
    Represents1: 'Starting Point: The time of submitting forecast (pre-stock) report.  End Point: The time when the standard product is produced.',
    Represents2: '2. The product readiness time = Lead Time + Order Preparation Time, logistics time needs to be calculated separately based on actual conditions.',
    Represents3: '3. If there is a single batch of goods to exceed the maximum number of normal demand, the lead time may be extended accordingly, please consult Ruijie sales or marketing planner.',
    Represents4: '4. For new products, delisted, pre-delisted products, please consult Ruijie sales or market planning for the lead time.',
    orderPreparation: 'Order Preparation Time refers to the time from order confirmation to product readiness (assuming that a forecast (pre-stock) report has been submitted and the report period is sufficient).',
    // 服务产品线Tips提示配置
    serviceProductTispTtile: `Ruijie Networks divides products into categories A, B1, B, Cand D based on the difficulty and risk of product
    delivery.`,
    serviceProductTispContent1: `Class A products: Installation and configuration are difficultand risky, high-end new products, new solutions
    or complex solutions.`,
    serviceProductTispContent2: `Class B1 products: High-end products or technically compleex solutions that are difficult to install and
    configure.`,
    serviceProductTispContent3: `Class B products: Moderate installation and configuration difficuIty, low risk, mid-to-high-end products.`,
    serviceProductTispContent4: `Class C products: Mid-to-low-end products that are easy to instaall and configure and risk-free.`,
    serviceProductTispContent5: `Class D products: Terminal products that aree easy to install and configure.`,
    // ---end
    serviceClassification: 'Service Category',
    specialInstructions: 'Remarks',
    alternativeModels: 'Replacement Model',
    more: 'More',
    collectionOperation: 'Favorite',
    loadMore: 'More',
    productModelOrQueryContains: 'Search for Device Model or Description',
    numberOf: 'Set',
    saveChanges: 'Save',
    saveClose: 'Save and Close',
    delete: 'Delete',
    copy: 'Copy',
    amount: 'Total',
    serviceConsultTube: 'Contact the distributor for discount details',
    quantitySet: 'Quantity',
    unit: 'Unit',
    type: 'Type',
    powerConsumption: 'Power Consumption (W)',
    replaceModel: 'Replacement Model',
    parameter: 'Parameters'
  },
  // 已添加产品
  productAdded: {
    jumpRemind: 'Tips for product configuration relationship',
    continueJump: 'Continue',
    myQuotation: 'My Price List',
    productConfigurationGroup: 'Product Config Group',
    addProduct: 'Add Product',
    productAdded: 'Added Products',
    selectAll: 'Select All',
    delete: 'Delete',
    copy: 'Copy',
    collectionProduction: 'collectionProduction',
    configurationGroupName: 'Config Group Name',
    priceRMB: 'Price (USD)',
    amount: 'Total',
    serviceConsultTube: 'Contact the distributor for discount details',
    myFavorite: 'Favorites',
    back: 'Back',
    save: 'Save',
    productName: 'Product Name',
    productModel: 'Product Model',
    productDes: 'Description',
    expandOrCloseAll: 'Expand/Collapse All',
    quantitySet: 'Quantity',
    unit: 'Unit',
    serviceClassification: 'Service Category',
    status: 'Status',
    serviceConfiguration: 'Service Configuration',
    batchSelectionService: 'Batch Selection Service',
    type: 'Type',
    specialInstructions: 'Remarks',
    powerConsumption: 'Power Consumption (W)',
    replaceModel: 'Replacement Model',
    remarks: 'Remarks',
    parameter: 'Parameters',
    operate: 'Action',
    noteInformation: 'Remarks',
    pleaseEnterNoteInformation: 'Enter remarks',
    pleaseCheckFavorite: 'Select the target product combination',
    oncePowerConsumption: 'Power Consumption per Device(W)',
    numberOf: 'Set',
    discountFont: 'discountFont', // 第二批翻译,丢失的字段
    eploymentConfiguration: 'Expand Config',
    clickRemove: 'Click to drag',
    parameterMessage: 'Parameter Info',
    inputParameterMessage: 'Enter parameter information',
    check: 'View',
    replace: 'Replace',
    remove: 'Drag',
    message_001: 'The selected series and products will be deleted. Continue?',
    prompt: 'Tip',
    message_003: 'Are you sure you want to replace the product? If  a device is selected, its accessories will be cleared',
    message_004: 'Are you sure you want to copy the series? The copied series will appear at the bottom. Continue?',
    message_005: 'Are you sure you want to copy the contents? The copied contents will appear at the bottom. Continue?',
    message_006: 'Are you sure you want to cancel Vendor Implementation Service for All Products?',
    message_007: 'Are you sure you want to adopt Vendor Implementation Service for All Products?',
    message_008: 'Only one series can be selected at a time for the favorite product combination',
    message_009: 'Are you sure you want to replace the product?',
    selectVolumeService: 'Please select the same service package product for configuration!',
    configureDragBox: 'Config Group Sorting Drag Box',
    networkAnomaly: 'Network Error',
    saveSucceeded: 'Save succeeded',
    replaceSucceeded: 'replaceSucceeded',
    saveFail: 'saveFail',
    copyFail: 'copyFail',
    hasBeenDelete: 'hasBeenDelete',
    nameUpdateSucceeded: 'nameUpdateSucceeded',
    addProductSucceeded: 'addProductSucceeded',
    deleteSucceeded: 'deleteSucceeded',
    // qualificationsName:'qualificationsName',
    // qualificationsType:'qualificationsType',
    // qualificationsAuthentication:'qualificationsAuthentication',
    dateIssue: 'Issuance Date',
    expiryDate: 'Expiry Date',
    replaceProduct: 'Replacement Product',
    needReplaceProduct: 'Replaced Product Model:',
    enterProductModel: 'Enter device model',
    otherHost: 'Other Series:',
    select: 'Query',
    tryMyBestLoading: 'Loading...',
    productState: 'Product Status',
    typAndProjectCycle: 'typAndProjectCycle',
    updateSuccess: 'Modify the success!',
    updateFail: 'updateFail',
    saveFailed: 'saveFailed',
    addProductTogether: 'Add Product Combination',
    togetherName: 'togetherName',
    pleaseEnterTheContent: 'Please enter the content',
    teamName: 'Group Name',
    editConfigurationGroup: 'editConfigurationGroup',
  },
  // 我的收藏模块
  myCollection: {
    accordingProductClassification: 'Load Category by Product Line',
    search: 'Search',
    reset: 'Reset',
    close: 'Close',
    searchProductModel: 'Load Category by Product Line',
    searchPortfolioName: 'Search by Product Combination Name'
  },
  // 出口合规检测模块（合规要求：统一英文展示）
  exportCompliance: {
    dialogTitle: 'Export Compliance Risk Alert / Block',
    cancel: 'Cancel',
    confirm: 'Confirm',
    continue: 'Continue',
    submitReview: 'Submit Review',
    reviewPending: 'A review has already been submitted and is being processed. Please wait for the result.',
    reviewSubmitted: 'The review request has been submitted successfully.',
    reviewSubmitFailed: 'Failed to submit the review request. Please try again.',
    reviewRejected: 'The review was not approved. You may submit a new review request.',
    systemError: 'The export compliance detection service is temporarily unavailable. You may continue or cancel.',
    refreshSuccess: 'Review status refreshed.',
    refreshFailed: 'Failed to refresh review status. Please try again.',
    statusPending: 'Pending Review',
    statusPassed: 'Review Approved',
    statusRejected: 'Review Not Approved',
    releaseFailed: 'Failed to record the manual release. Please try again.'
  }
};
